module.exports = __webpack_public_path__ + "static/media/link.a2c952f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neonat/icons/link.svg
// module id = 317
// module chunks = 1